import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "ltcs-hr-request-modal" }
const _hoisted_2 = { class: "ltcs-hr-request-modal__header" }
const _hoisted_3 = { class: "header-title-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "polling-badge"
}
const _hoisted_5 = { class: "ltcs-hr-request-modal__body" }
const _hoisted_6 = { class: "request-target-section" }
const _hoisted_7 = { class: "ltcs-params-preview" }
const _hoisted_8 = { class: "preview-title" }
const _hoisted_9 = { class: "preview-chips" }
const _hoisted_10 = { class: "ym-picker" }
const _hoisted_11 = { class: "ym-display" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "ym-code"
}
const _hoisted_14 = { class: "request-cards" }
const _hoisted_15 = { class: "request-card__content" }
const _hoisted_16 = { class: "request-card__title" }
const _hoisted_17 = { class: "request-card__desc" }
const _hoisted_18 = {
  key: 0,
  class: "request-card__status"
}
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = { class: "history-section" }
const _hoisted_21 = { class: "history-section__header" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "history-empty"
}
const _hoisted_24 = {
  key: 1,
  class: "history-list"
}
const _hoisted_25 = { class: "history-item__main" }
const _hoisted_26 = { class: "history-type" }
const _hoisted_27 = { class: "history-params" }
const _hoisted_28 = { class: "history-item__meta" }
const _hoisted_29 = { class: "history-time" }
const _hoisted_30 = {
  key: 0,
  class: "history-item__progress"
}
const _hoisted_31 = { class: "history-item__actions" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "ltcs-hr-request-modal__footer" }
const _hoisted_35 = { class: "result-modal result-modal--large" }
const _hoisted_36 = {
  key: 0,
  class: "header-subtitle"
}
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = {
  key: 0,
  class: "error-section"
}
const _hoisted_39 = { class: "section-title" }
const _hoisted_40 = { class: "error-message" }
const _hoisted_41 = {
  key: 1,
  class: "labor-cost-section"
}
const _hoisted_42 = {
  key: 0,
  class: "labor-cost-card"
}
const _hoisted_43 = { class: "labor-cost-title-bar" }
const _hoisted_44 = { class: "labor-cost-table" }
const _hoisted_45 = { class: "amount" }
const _hoisted_46 = { class: "amount" }
const _hoisted_47 = { class: "amount highlight" }
const _hoisted_48 = { class: "amount highlight" }
const _hoisted_49 = { class: "amount" }
const _hoisted_50 = { class: "amount" }
const _hoisted_51 = { class: "amount" }
const _hoisted_52 = { class: "labor-cost-summary" }
const _hoisted_53 = { class: "summary-item" }
const _hoisted_54 = { class: "value" }
const _hoisted_55 = {
  key: 1,
  class: "no-data-message"
}
const _hoisted_56 = {
  key: 2,
  class: "data-table-section"
}
const _hoisted_57 = { class: "query-conditions" }
const _hoisted_58 = { class: "condition-title" }
const _hoisted_59 = { class: "condition-items" }
const _hoisted_60 = { class: "condition-item" }
const _hoisted_61 = { class: "condition-value" }
const _hoisted_62 = { class: "condition-item" }
const _hoisted_63 = { class: "condition-value" }
const _hoisted_64 = {
  key: 0,
  class: "condition-item"
}
const _hoisted_65 = { class: "condition-value highlight" }
const _hoisted_66 = { class: "summary-cards" }
const _hoisted_67 = { class: "summary-card" }
const _hoisted_68 = { class: "card-icon" }
const _hoisted_69 = { class: "card-content" }
const _hoisted_70 = { class: "card-value" }
const _hoisted_71 = { class: "card-label" }
const _hoisted_72 = {
  key: 0,
  class: "summary-card"
}
const _hoisted_73 = { class: "card-icon" }
const _hoisted_74 = { class: "card-content" }
const _hoisted_75 = { class: "card-value" }
const _hoisted_76 = {
  key: 1,
  class: "summary-card"
}
const _hoisted_77 = { class: "card-icon" }
const _hoisted_78 = { class: "card-content" }
const _hoisted_79 = { class: "card-value" }
const _hoisted_80 = {
  key: 2,
  class: "summary-card"
}
const _hoisted_81 = { class: "card-icon" }
const _hoisted_82 = { class: "card-content" }
const _hoisted_83 = { class: "card-value" }
const _hoisted_84 = {
  key: 3,
  class: "summary-card"
}
const _hoisted_85 = { class: "card-icon" }
const _hoisted_86 = { class: "card-content" }
const _hoisted_87 = { class: "card-value" }
const _hoisted_88 = {
  key: 4,
  class: "summary-card summary-card--portal-raw"
}
const _hoisted_89 = { class: "card-icon" }
const _hoisted_90 = { class: "card-content" }
const _hoisted_91 = { class: "card-value" }
const _hoisted_92 = { class: "card-icon" }
const _hoisted_93 = { class: "card-content" }
const _hoisted_94 = { class: "card-value duplicate-link" }
const _hoisted_95 = { class: "card-label" }
const _hoisted_96 = { class: "search-area" }
const _hoisted_97 = { class: "total-count" }
const _hoisted_98 = { class: "no-data" }
const _hoisted_99 = { class: "pagination-area" }
const _hoisted_100 = { class: "modal-footer" }

import { computed, watch, inject, ref, type Ref } from 'vue';
import { useStore } from 'vuex';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import LtcsDuplicateDialog from '@/components/member/request/LtcsDuplicateDialog.vue';
import LtcsClaimDetailPreferNotice from '@/components/member/request/LtcsClaimDetailPreferNotice.vue';
import LtcsRequestConfirmDialog from '@/components/member/request/LtcsRequestConfirmDialog.vue';
import {
  useLtcsMacroRequest,
  HR_LTCS_REQUEST_TYPES,
  LTCS_TYPE_LABELS,
  normalizeLtcsType,
} from '@/composables/useLtcsMacroRequest';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsHrRequestModal',
  props: {
    modelValue: { type: Boolean },
    memberCode: {},
    bizGubun: {},
    yearMonth: {},
    allowedTypes: { default: () => HR_LTCS_REQUEST_TYPES }
  },
  emits: ["update:modelValue", "updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const isAdmin = computed(
  () => Number(store.getters.actualRoleLevel ?? store.getters.roleLevel ?? 0) >= 60
);

const injectedMemberData = inject<Ref<any>>('memberData', ref(null));
const injectedBizGubun = inject<Ref<string>>('selectedBizGubun', ref(''));

const memberCodeRef = computed(() =>
  props.memberCode || injectedMemberData?.value?.m_code || ''
);
const bizGubunRef = computed(() =>
  props.bizGubun || injectedBizGubun?.value || ''
);
const toYearMonth = (raw: string) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.length < 6) return '';
  const ym = digits.slice(0, 6);
  const month = Number(ym.slice(4, 6));
  if (month < 1 || month > 12) return '';
  return ym;
};

const currentYearMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
};

const selectedYearMonth = ref(toYearMonth(props.yearMonth) || currentYearMonth());

const yearMonthInputValue = computed(() => {
  const ym = selectedYearMonth.value;
  if (ym.length !== 6) return '';
  return `${ym.slice(0, 4)}-${ym.slice(4, 6)}`;
});

const shiftYearMonth = (delta: number) => {
  const base = toYearMonth(selectedYearMonth.value) || currentYearMonth();
  const year = Number(base.slice(0, 4));
  const month = Number(base.slice(4, 6));
  const next = new Date(year, month - 1 + delta, 1);
  selectedYearMonth.value = `${next.getFullYear()}${String(next.getMonth() + 1).padStart(2, '0')}`;
};

const onYearMonthInput = (event: Event) => {
  const next = toYearMonth((event.target as HTMLInputElement).value);
  if (next) selectedYearMonth.value = next;
};

const dialog = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const {
  requestTypes,
  filteredHistoryItems,
  historyLoading,
  loadingMap,
  hasActiveRequest,
  snackbar,
  resultModal,
  scheduleLoading,
  scheduleSearch,
  scheduleData,
  duplicateDialogShow,
  duplicateLoading,
  duplicateGroups,
  duplicateCount,
  duplicateGroupCount,
  duplicateIdxKey,
  currentPage,
  itemsPerPage,
  sortBy,
  totalPages,
  scheduleHeaders,
  showCaregiverCount,
  showRecipientCount,
  showDateCount,
  getTypeLabel,
  getLatestProgressMessage,
  getStatusLabel,
  getParamsLabel,
  getLatestRequestForType,
  formatDateTime,
  formatYearMonth,
  formatNumber,
  formatDateFull,
  formatTime,
  formatTimeRange,
  formatMoney,
  formatRate,
  formatYn,
  getServiceTypeColor,
  getClaimStatusColor,
  confirmDialog,
  submitRequest,
  confirmSubmitRequest,
  cancelRequest,
  showResultModal,
  closeResultModal,
  openDuplicateDialog,
  searchScheduleData,
  clearSearch,
  onSortChange,
  onPageChange,
  onItemsPerPageChange,
  loadHistory,
  formatProgressMessage,
} = useLtcsMacroRequest({
  memberCode: memberCodeRef,
  bizGubun: bizGubunRef,
  selectedYearMonth,
  allowedTypes: props.allowedTypes,
  verboseErrors: isAdmin,
});

const bizGubun = bizGubunRef;
const facilityName = computed(
  () => injectedMemberData?.value?.m_name || injectedMemberData?.value?.m_facility_name || ''
);

const closeModal = () => {
  dialog.value = false;
};

const getCardStatus = (type: string) => {
  const normalized = normalizeLtcsType(type);
  const needsYm = LTCS_TYPE_LABELS[normalized]?.needsYearMonth ?? false;
  const ym = needsYm ? selectedYearMonth.value : undefined;
  const latest = getLatestRequestForType(type, ym);
  if (!latest) return null;

  if (latest.cmq_status === 'pending' || latest.cmq_status === 'processing') {
    const progress = formatProgressMessage(getLatestProgressMessage(latest) || '');
    return {
      label: progress || getStatusLabel(latest.cmq_status),
      color: 'processing',
    };
  }
  if (latest.cmq_status === 'completed') {
    return { label: '최근 요청 완료', color: 'ready' };
  }
  if (latest.cmq_status === 'failed') {
    return { label: '최근 요청 실패', color: 'failed' };
  }
  return null;
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      selectedYearMonth.value = toYearMonth(props.yearMonth) || currentYearMonth();
      if (memberCodeRef.value) loadHistory();
    }
  }
);

watch(hasActiveRequest, (active, wasActive) => {
  if (wasActive && !active) {
    emit('updated');
  }
});

watch(filteredHistoryItems, () => {
  if (props.modelValue) {
    emit('updated');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
      "max-width": "680",
      scrollable: "",
      persistent: "",
      "z-index": 10100,
      "content-class": "ltcs-hr-request-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#1e3a5f"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-cloud-download-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[16] || (_cache[16] = _createElementVNode("h3", null, "롱텀케어 자료요청", -1)),
              (_unref(hasActiveRequest))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      size: "12",
                      width: "2",
                      color: "#1565c0"
                    }),
                    _cache[15] || (_cache[15] = _createTextVNode(" 갱신 중 ", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "close-btn",
              "aria-label": "닫기",
              onClick: closeModal
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(LoadingOverlay, {
              show: _unref(historyLoading) && _unref(filteredHistoryItems).length === 0,
              text: "불러오는 중..."
            }, null, 8, ["show"]),
            _createElementVNode("div", _hoisted_6, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "section-label" }, "요청 대상", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    color: "#1e3a5f"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[19] || (_cache[19] = _createTextVNode(" 요청 시 전송되는 조건 ", -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["preview-chip preview-chip--ym", { 'is-warn': !selectedYearMonth.value }])
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("em", null, "조회 연월", -1)),
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ym-step",
                        "aria-label": "이전 달",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (shiftYearMonth(-1)))
                      }, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("mdi-chevron-left", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("label", _hoisted_11, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(formatYearMonth)(selectedYearMonth.value) || '미선택'), 1),
                        _createElementVNode("input", {
                          type: "month",
                          class: "ym-input",
                          value: yearMonthInputValue.value,
                          "aria-label": "조회 연월 선택",
                          onChange: onYearMonthInput
                        }, null, 40, _hoisted_12)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ym-step",
                        "aria-label": "다음 달",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (shiftYearMonth(1)))
                      }, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    (selectedYearMonth.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(selectedYearMonth.value), 1))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["preview-chip", { 'is-warn': !_unref(bizGubun) }])
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("em", null, "사업구분", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_unref(bizGubun) || '미선택'), 1)
                  ], 2)
                ]),
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "preview-hint" }, "조회 연월은 화살표나 연월을 눌러 바꿀 수 있습니다. 요청 버튼을 누르면 위 값으로 전송하기 전 확인창이 표시됩니다.", -1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(requestTypes), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.type,
                    class: "request-card"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["request-card__icon", `request-card__icon--${item.color}`])
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.icon), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ], 2),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.description), 1),
                      (getCardStatus(item.type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["status-dot", `status-dot--${getCardStatus(item.type)?.color}`])
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(getCardStatus(item.type)?.label), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "request-card__btn",
                      disabled: !!_unref(loadingMap)[item.type],
                      onClick: ($event: any) => (_unref(submitRequest)(item.type))
                    }, [
                      (_unref(loadingMap)[item.type])
                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                            key: 0,
                            indeterminate: "",
                            size: "14",
                            width: "2",
                            color: "white"
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("요청")
                          ], 64))
                    ], 8, _hoisted_19)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "section-label" }, "요청 내역", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "refresh-btn",
                  disabled: _unref(historyLoading),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(loadHistory) && _unref(loadHistory)(...args)))
                }, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    class: _normalizeClass({ 'mdi-spin': _unref(historyLoading) })
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("mdi-refresh", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"])
                ], 8, _hoisted_22)
              ]),
              (_unref(filteredHistoryItems).length === 0 && !_unref(historyLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 요청 내역이 없습니다 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredHistoryItems).slice(0, 15), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.cmq_idx,
                        class: "history-item"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(getTypeLabel)(item.cmq_type)), 1),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(getParamsLabel)(item.cmq_params)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(formatDateTime)(item.cmq_requested_at)), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["history-status", `history-status--${item.cmq_status}`])
                          }, [
                            (item.cmq_status === 'processing')
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "10",
                                  width: "2",
                                  color: "#0288d1",
                                  class: "mr-1"
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_unref(getStatusLabel)(item.cmq_status)), 1)
                          ], 2)
                        ]),
                        (_unref(getLatestProgressMessage)(item))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(formatProgressMessage)(_unref(getLatestProgressMessage)(item))), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_31, [
                          (item.cmq_status === 'completed' || item.cmq_status === 'failed')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass(["history-action-btn", item.cmq_status === 'completed' ? 'is-success' : 'is-error']),
                                onClick: ($event: any) => (_unref(showResultModal)(item))
                              }, [
                                _createVNode(_component_v_icon, { size: "13" }, {
                                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                    _createTextVNode("mdi-eye-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[29] || (_cache[29] = _createTextVNode(" 결과 ", -1))
                              ], 10, _hoisted_32))
                            : _createCommentVNode("", true),
                          (item.cmq_status === 'pending' || item.cmq_status === 'processing')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "history-action-btn is-cancel",
                                onClick: ($event: any) => (_unref(cancelRequest)(item))
                              }, " 취소 ", 8, _hoisted_33))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
            ])
          ]),
          _createElementVNode("footer", _hoisted_34, [
            _createVNode(_component_v_btn, {
              variant: "text",
              class: "btn-close",
              onClick: closeModal
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("닫기", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(resultModal).show,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(resultModal).show) = $event)),
      "max-width": "2000",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-header", _unref(resultModal).status])
          }, [
            _createElementVNode("h3", null, [
              _createVNode(_component_v_icon, {
                size: "20",
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(resultModal).status === 'completed' ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_unref(resultModal).status === 'completed' ? '실행 완료' : '실행 실패') + " ", 1),
              (_unref(resultModal).status === 'completed')
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, " - " + _toDisplayString(_unref(getTypeLabel)(_unref(resultModal).type)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(closeResultModal) && _unref(closeResultModal)(...args)))
            }, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ], 2),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(LoadingOverlay, {
              show: _unref(scheduleLoading),
              text: "데이터 불러오는 중..."
            }, null, 8, ["show"]),
            (_unref(resultModal).status === 'failed' && _unref(resultModal).errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "error",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode("mdi-alert", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[33] || (_cache[33] = _createTextVNode(" 실패 원인 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(resultModal).errorMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(resultModal).status === 'completed' && _unref(resultModal).type === 'caion_ltcs_labor_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (_unref(scheduleData).items.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, " (" + _toDisplayString(_unref(formatYearMonth)(_unref(scheduleData).items[0]?.yearMonth)) + ") " + _toDisplayString(_unref(scheduleData).items[0]?.facilityType || '-') + " 심사결정금액 ", 1),
                        _createElementVNode("table", _hoisted_44, [
                          _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", { class: "header-row-1" }, [
                              _createElementVNode("th", { colspan: "2" }, "① 장기요양급여비용(②+③+④)"),
                              _createElementVNode("th", { colspan: "2" }, "② 인건비 비율 반영"),
                              _createElementVNode("th", { colspan: "2" }, "③ 인건비 비율 미반영"),
                              _createElementVNode("th", null, "④ 본인부담금")
                            ]),
                            _createElementVNode("tr", { class: "header-row-2" }, [
                              _createElementVNode("th", null, "비용"),
                              _createElementVNode("th", null, "가산"),
                              _createElementVNode("th", null, "비용"),
                              _createElementVNode("th", null, "가산"),
                              _createElementVNode("th", null, "비용"),
                              _createElementVNode("th", null, "가산"),
                              _createElementVNode("th", null, "비용")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_45, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.totalCost)), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.totalAdd)), 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.laborCost)), 1),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.laborAdd)), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.nonLaborCost)), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.nonLaborAdd)), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(formatNumber)(_unref(scheduleData).items[0]?.selfPayCost)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "인건비 반영 합계", -1)),
                            _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(formatNumber)((_unref(scheduleData).items[0]?.laborCost || 0) + (_unref(scheduleData).items[0]?.laborAdd || 0))) + "원 ", 1)
                          ]),
                          (_unref(duplicateCount) > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "duplicate-inline-btn",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(openDuplicateDialog) && _unref(openDuplicateDialog)(...args)))
                              }, " 중복 " + _toDisplayString(_unref(duplicateCount).toLocaleString()) + "건 ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createVNode(_component_v_icon, {
                          size: "48",
                          color: "grey-lighten-2"
                        }, {
                          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                            _createTextVNode("mdi-file-document-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[37] || (_cache[37] = _createElementVNode("p", null, "해당 조건의 인건비지출내역이 없습니다.", -1))
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_unref(resultModal).status === 'completed' && _unref(resultModal).type !== 'caion_ltcs_labor_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                          _createTextVNode("mdi-filter-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[39] || (_cache[39] = _createTextVNode(" 조회 조건 ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "condition-label" }, "사업구분", -1)),
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(bizGubun) || '전체'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "condition-label" }, "연월", -1)),
                        _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(formatYearMonth)(_unref(resultModal).yearMonth) || '전체'), 1)
                      ]),
                      (_unref(scheduleSearch))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "condition-label" }, "검색어", -1)),
                            _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(scheduleSearch)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_v_icon, { color: "primary" }, {
                          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                            _createTextVNode("mdi-calendar-check", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(scheduleData).summary.totalCount?.toLocaleString() || 0), 1),
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(normalizeLtcsType)(_unref(resultModal).type) === 'caion_ltcs_claim_detail' ? '방문 건수' : '전체 건수'), 1)
                      ])
                    ]),
                    (_unref(showCaregiverCount))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_v_icon, { color: "success" }, {
                              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                _createTextVNode("mdi-account-hard-hat", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(scheduleData).summary.caregiverCount || 0), 1),
                            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "card-label" }, "종사자", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(showRecipientCount))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_v_icon, { color: "secondary" }, {
                              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                _createTextVNode("mdi-account-heart", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("span", _hoisted_79, _toDisplayString(_unref(scheduleData).summary.recipientCount || 0), 1),
                            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "card-label" }, "수급자", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(showDateCount))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createVNode(_component_v_icon, { color: "info" }, {
                              default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                _createTextVNode("mdi-calendar-range", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(scheduleData).summary.dateCount || 0) + "일", 1),
                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "card-label" }, "날짜수", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(normalizeLtcsType)(_unref(resultModal).type) === 'caion_ltcs_claim_detail')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_v_icon, { color: "warning" }, {
                              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                _createTextVNode("mdi-currency-krw", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("span", _hoisted_87, _toDisplayString((_unref(scheduleData).summary.totalFee || 0).toLocaleString()) + "원", 1),
                            _cache[51] || (_cache[51] = _createElementVNode("span", { class: "card-label" }, "총 수가", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(normalizeLtcsType)(_unref(resultModal).type) === 'caion_ltcs_claim_detail' && (_unref(scheduleData).summary.portalRawCount || 0) > (_unref(scheduleData).summary.totalCount || 0))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createVNode(_component_v_icon, { color: "#1565c0" }, {
                              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                _createTextVNode("mdi-file-document-multiple-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("span", _hoisted_91, _toDisplayString((_unref(scheduleData).summary.portalRawCount || 0).toLocaleString()) + "줄", 1),
                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "card-label" }, "포털 원본", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(duplicateCount) > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          type: "button",
                          class: "summary-card summary-card--duplicate",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(openDuplicateDialog) && _unref(openDuplicateDialog)(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_92, [
                            _createVNode(_component_v_icon, { color: "error" }, {
                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                _createTextVNode("mdi-content-duplicate", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("span", _hoisted_94, _toDisplayString(_unref(duplicateCount).toLocaleString()) + "건", 1),
                            _createElementVNode("span", _hoisted_95, _toDisplayString(_unref(normalizeLtcsType)(_unref(resultModal).type) === 'caion_ltcs_claim_detail'
                    ? '동일 방문 중복 (클릭)'
                    : '중복 데이터 (클릭)'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_unref(normalizeLtcsType)(_unref(resultModal).type) === 'caion_ltcs_claim_detail')
                    ? (_openBlock(), _createBlock(LtcsClaimDetailPreferNotice, {
                        key: 0,
                        "portal-raw-count": _unref(scheduleData).summary.portalRawCount || 0,
                        "display-count": _unref(scheduleData).summary.totalCount || 0,
                        "status-pair-count": _unref(scheduleData).summary.statusPairCount || 0
                      }, null, 8, ["portal-raw-count", "display-count", "status-pair-count"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_96, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _unref(scheduleSearch),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(scheduleSearch) ? (scheduleSearch).value = $event : null)),
                      "prepend-inner-icon": "mdi-magnify",
                      label: "이름 검색 (요양보호사/수급자)",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      style: {"max-width":"300px"},
                      onKeyup: _withKeys(_unref(searchScheduleData), ["enter"]),
                      "onClick:clear": _unref(clearSearch)
                    }, null, 8, ["modelValue", "onKeyup", "onClick:clear"]),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      class: "btn-search",
                      onClick: _unref(searchScheduleData)
                    }, {
                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                        _createTextVNode("검색", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("span", _hoisted_97, [
                      _cache[56] || (_cache[56] = _createTextVNode(" 총 ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_unref(scheduleData).total.toLocaleString()), 1),
                      _cache[57] || (_cache[57] = _createTextVNode("건 ", -1)),
                      (_unref(normalizeLtcsType)(_unref(resultModal).type) === 'caion_ltcs_claim_detail')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (방문)")
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_v_data_table, {
                    headers: _unref(scheduleHeaders),
                    items: _unref(scheduleData).items,
                    loading: _unref(scheduleLoading),
                    "items-per-page": _unref(itemsPerPage),
                    page: _unref(currentPage),
                    class: "schedule-table",
                    density: "compact",
                    "sort-by": _unref(sortBy),
                    "hide-default-footer": "",
                    "onUpdate:sortBy": _unref(onSortChange)
                  }, {
                    "item.clsr_wdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateTime)(item.clsr_wdate)), 1)
                    ]),
                    "item.clsr_rdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateTime)(item.clsr_rdate)), 1)
                    ]),
                    "item.clsr_service_type": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: _unref(getServiceTypeColor)(item.clsr_service_type)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clsr_service_type || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clci_birth_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clci_birth_date)), 1)
                    ]),
                    "item.clci_work_start_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clci_work_start_date)), 1)
                    ]),
                    "item.clci_work_end_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clci_work_end_date)), 1)
                    ]),
                    "item.clci_wdate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateTime)(item.clci_wdate)), 1)
                    ]),
                    "item.clsp_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clsp_date)), 1)
                    ]),
                    "item.clsp_start_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatTime)(item.clsp_start_time)), 1)
                    ]),
                    "item.clsp_end_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatTime)(item.clsp_end_time)), 1)
                    ]),
                    "item.clsp_is_family": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatYn)(item.clsp_is_family)), 1)
                    ]),
                    "item.clsp_caregiver_birth": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clsp_caregiver_birth)), 1)
                    ]),
                    "item.clsp_service_type": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: _unref(getServiceTypeColor)(item.clsp_service_type)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clsp_service_type || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clc_caregiver_birth": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clc_caregiver_birth)), 1)
                    ]),
                    "item.clc_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clc_date)), 1)
                    ]),
                    "item.clc_plan_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatTimeRange)(item.clc_plan_start_time, item.clc_plan_end_time)), 1)
                    ]),
                    "item.clc_work_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatTimeRange)(item.clc_work_start_time, item.clc_work_end_time)), 1)
                    ]),
                    "item.clc_is_family": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatYn)(item.clc_is_family)), 1)
                    ]),
                    "item.clc_service_type": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: _unref(getServiceTypeColor)(item.clc_service_type)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clc_service_type || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clcd_status": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        size: "x-small",
                        color: _unref(getClaimStatusColor)(item.clcd_status)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.clcd_status || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.clcd_date": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatDateFull)(item.clcd_date)), 1)
                    ]),
                    "item.clcd_service_time": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatTimeRange)(item.clcd_service_start_time, item.clcd_service_end_time)), 1)
                    ]),
                    "item.clcd_fee": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatMoney)(item.clcd_fee)), 1)
                    ]),
                    "item.clcd_deduction_score": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(item.clcd_deduction_score ?? '-'), 1)
                    ]),
                    "item.clcd_deduction_rate": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_unref(formatRate)(item.clcd_deduction_rate)), 1)
                    ]),
                    "no-data": _withCtx(() => [
                      _createElementVNode("div", _hoisted_98, [
                        _createVNode(_component_v_icon, {
                          size: "40",
                          color: "grey-lighten-2"
                        }, {
                          default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                            _createTextVNode("mdi-calendar-blank", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[59] || (_cache[59] = _createElementVNode("p", null, "조회된 데이터가 없습니다.", -1))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "loading", "items-per-page", "page", "sort-by", "onUpdate:sortBy"]),
                  _createElementVNode("div", _hoisted_99, [
                    _createVNode(_component_v_select, {
                      modelValue: _unref(itemsPerPage),
                      "onUpdate:modelValue": [
                        _cache[8] || (_cache[8] = ($event: any) => (_isRef(itemsPerPage) ? (itemsPerPage).value = $event : null)),
                        _unref(onItemsPerPageChange)
                      ],
                      items: [20, 50, 100],
                      label: "페이지당",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      style: {"width":"110px"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_pagination, {
                      modelValue: _unref(currentPage),
                      "onUpdate:modelValue": [
                        _cache[9] || (_cache[9] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
                        _unref(onPageChange)
                      ],
                      length: _unref(totalPages),
                      "total-visible": 7,
                      density: "compact"
                    }, null, 8, ["modelValue", "length", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-cancel",
              onClick: _unref(closeResultModal)
            }, {
              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                _createTextVNode("닫기", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(LtcsDuplicateDialog, {
      modelValue: _unref(duplicateDialogShow),
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(duplicateDialogShow) ? (duplicateDialogShow).value = $event : null)),
      loading: _unref(duplicateLoading),
      "duplicate-count": _unref(duplicateCount),
      "duplicate-group-count": _unref(duplicateGroupCount),
      groups: _unref(duplicateGroups),
      "table-headers": _unref(scheduleHeaders),
      "idx-key": _unref(duplicateIdxKey),
      "source-type": _unref(normalizeLtcsType)(_unref(resultModal).type)
    }, null, 8, ["modelValue", "loading", "duplicate-count", "duplicate-group-count", "groups", "table-headers", "idx-key", "source-type"]),
    _createVNode(LtcsRequestConfirmDialog, {
      modelValue: _unref(confirmDialog).show,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(confirmDialog).show) = $event)),
      "type-name": _unref(confirmDialog).typeName,
      "year-month": _unref(confirmDialog).yearMonth,
      "biz-gubun": _unref(confirmDialog).bizGubun,
      "facility-name": facilityName.value,
      "needs-year-month": _unref(confirmDialog).needsYearMonth,
      loading: !!_unref(loadingMap)[_unref(confirmDialog).type],
      onConfirm: _unref(confirmSubmitRequest)
    }, null, 8, ["modelValue", "type-name", "year-month", "biz-gubun", "facility-name", "needs-year-month", "loading", "onConfirm"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(snackbar).show,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(snackbar).show) = $event)),
      color: _unref(snackbar).color,
      timeout: 3000
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(snackbar).message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ], 64))
}
}

})